var UserLocalizationConfigStorage_1;
import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { LocaleObject } from "../locale/Locale";
import { TypedLocalStorage } from "../../storage";
let UserLocalizationConfigStorage = UserLocalizationConfigStorage_1 = class UserLocalizationConfigStorage extends TypedLocalStorage {
    constructor() {
        super(UserLocalizationConfigStorage_1.LOCAL_STORAGE_KEY, undefined);
    }
    onLoad(value) {
        if (value === undefined)
            return undefined;
        return {
            selectedLocale: value.selectedLocale ? LocaleObject.parse(value.selectedLocale) : undefined,
            selectedCurrency: value.selectedCurrency,
        };
    }
    onSave(value) {
        if (value === undefined)
            return undefined;
        return {
            selectedLocale: value.selectedLocale?.toJSON(),
            selectedCurrency: value.selectedCurrency,
        };
    }
};
UserLocalizationConfigStorage.LOCAL_STORAGE_KEY = "lv.localization";
UserLocalizationConfigStorage = UserLocalizationConfigStorage_1 = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], UserLocalizationConfigStorage);
export { UserLocalizationConfigStorage };
//# sourceMappingURL=UserLocalizationConfigStorage.js.map